module.exports = __webpack_public_path__ + "img/email.670539ad.svg";